// src/api/modules/TrackingGeneralApi.js
import Methods from "../methods";

const getTrackingByChild = (context, { type, idChild }) => {
  const url = `api/tracking/${type}/${idChild}`;
  return Methods.doGet(context, url);
};

export default {
  getTrackingByChild
};



// WEBPACK FOOTER //
// ./src/api/modules/TrackingGeneralApi.js